export const ASSET_NAME = 'privacy-policy';

// Container Trader: the Privacy Policy page is built in code, so it no longer needs the
// Console page asset.
export const loadData = () => () => Promise.resolve();
